(() => {
  const $ = (q, r=document) => r.querySelector(q);
  const $$ = (q, r=document) => [...r.querySelectorAll(q)];

  // Fetch & render cart
  async function fetchCart(){ return (await fetch('/cart.js', {headers:{Accept:'application/json'}})).json(); }
  async function renderCart(){
    const cart = await fetchCart();
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    const count = $$('[data-cart-count]');
    count.forEach(c => c.textContent = cart.item_count);
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p style="font-family:var(--serif);font-size:22px;color:var(--muted);">Your bag is empty.</p>';
      if (foot) foot.innerHTML = '<a href="/collections/all" class="btn" style="width:100%;text-align:center;">Continue shopping</a>';
      return;
    }
    body.innerHTML = cart.items.map(i => `
      <div class="cart-line" data-key="${i.key}">
        <a href="${i.url}"><img src="${i.image}" alt="${i.product_title}"></a>
        <div>
          <div style="font-family:var(--serif);font-size:20px;">${i.product_title}</div>
          <div class="eyebrow eyebrow--sm">${i.variant_title || ''}</div>
          <div class="qty" style="margin-top:8px;">
            <button data-qty="${i.key}" data-delta="-1">−</button>
            <span>${i.quantity}</span>
            <button data-qty="${i.key}" data-delta="1">+</button>
          </div>
        </div>
        <div style="text-align:right;">
          <div style="font-family:var(--mono);font-size:13px;">${formatMoney(i.final_line_price)}</div>
          <button data-remove="${i.key}" class="btn-link" style="font-size:9px;">Remove</button>
        </div>
      </div>`).join('');
    if (foot) foot.innerHTML = `
      <div style="display:flex;justify-content:space-between;margin-bottom:16px;">
        <span class="eyebrow">Subtotal</span><span style="font-family:var(--serif);font-size:24px;">${formatMoney(cart.total_price)}</span>
      </div>
      <a href="/checkout" class="btn" style="width:100%;text-align:center;display:block;">Check out</a>
      <div class="eyebrow eyebrow--sm" style="text-align:center;margin-top:12px;">Shipping calculated at checkout</div>`;
  }
  function formatMoney(cents){
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    return new Intl.NumberFormat(undefined,{style:'currency',currency}).format(cents/100);
  }

  function openDrawer(){ const d=$('[data-cart-drawer]'); if(d){ d.classList.add('is-open'); renderCart(); } }
  function closeDrawer(){ const d=$('[data-cart-drawer]'); if(d) d.classList.remove('is-open'); }

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    const closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }
    const rm = e.target.closest('[data-remove]');
    if (rm) {
      await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:rm.dataset.remove,quantity:0})});
      renderCart(); return;
    }
    const q = e.target.closest('[data-qty]');
    if (q) {
      const line = q.closest('.cart-line');
      const cur = +line.querySelector('.qty span').textContent;
      const next = Math.max(0, cur + (+q.dataset.delta));
      await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:q.dataset.qty,quantity:next})});
      renderCart();
    }
    const acc = e.target.closest('[data-accordion]');
    if (acc) { const body = acc.nextElementSibling; if(body) body.hidden = !body.hidden; }
  });

  // Ajax add-to-cart on product form
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const oldTxt = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {method:'POST',body:fd,headers:{Accept:'application/json'}});
    if (btn) { btn.textContent = res.ok ? 'Added ✓' : 'Try again'; setTimeout(()=>{ btn.textContent = oldTxt; btn.disabled = false; }, 1400); }
    if (res.ok) openDrawer();
  });

  document.addEventListener('change', (e) => {
    const picker = e.target.closest('[data-variant-picker]');
    if (!picker) return;
    const id = e.target.value;
    const idInput = document.querySelector('[name="id"]');
    if (idInput) idInput.value = id;
  });

  // Initial header count
  fetchCart().then(c => $$('[data-cart-count]').forEach(el => el.textContent = c.item_count)).catch(()=>{});

  // Skin Quiz
  const Q=[
    {key:'type',tag:'01 · Your skin',q:'How would you describe your skin most days?',sub:'Pick whichever feels closest.',opts:[
      {id:'dry',l:'Dry — tight, sometimes flaky'},{id:'oily',l:'Oily — shiny by lunchtime'},
      {id:'combo',l:'Combination — oily T-zone'},{id:'sensitive',l:'Sensitive — reactive, red'}]},
    {key:'age',tag:'02 · Chapter',q:"What's your age range?",sub:'',opts:[
      {id:'20s',l:'20 – 29'},{id:'30s',l:'30 – 39'},{id:'40s',l:'40 – 49'},{id:'50',l:'50 and beyond'}]},
    {key:'concern',tag:'03 · Priority',q:"What's your #1 skin concern?",sub:'',opts:[
      {id:'brightness',l:'Dullness &amp; uneven tone'},{id:'lines',l:'Fine lines &amp; firmness'},
      {id:'spots',l:'Dark spots &amp; pigmentation'},{id:'hydration',l:'Dehydration &amp; dryness'},
      {id:'acne',l:'Breakouts &amp; blemishes'},{id:'redness',l:'Redness &amp; sensitivity'}]},
    {key:'routine',tag:'04 · Habits',q:'How much routine do you actually want?',sub:'',opts:[
      {id:'min',l:'Three products, tops.'},{id:'med',l:'Four to five.'},{id:'max',l:'The full ritual.'}]},
    {key:'sun',tag:'05 · Sun',q:'How often do you wear SPF?',sub:'',opts:[
      {id:'daily',l:'Every single day'},{id:'sun',l:"When it's sunny"},{id:'never',l:'Almost never'},{id:'summer',l:'Summer only'}]},
    {key:'sensitivity',tag:'06 · Reactions',q:'Does your skin react to actives?',sub:'',opts:[
      {id:'yes',l:'Very reactive'},{id:'sometimes',l:'Sometimes'},{id:'no',l:'Not really'},{id:'unsure',l:'Not sure'}]}
  ];
  const R = {
    brightness:{name:'The Golden Hour Routine',blurb:'Built to lift dullness and even out tone.',handles:['vitamin-c-face-serum','softwater-cleanser','daylight-spf-50']},
    lines:{name:'The Overnight Ritual',blurb:'Smoother texture, firmer feel.',handles:['melting-balm','the-overnight','second-skin-cream']},
    spots:{name:'The Fade Routine',blurb:'A patient, quietly powerful fade.',handles:['vitamin-c-face-serum','softwater-cleanser','the-overnight']},
    hydration:{name:'The Everyday Ritual',blurb:'Barrier-first hydration.',handles:['melting-balm','second-skin-cream','rescue-balm']},
    acne:{name:'The Clear Ritual',blurb:'Balance without stripping.',handles:['softwater-cleanser','the-overnight','daylight-spf-50']},
    redness:{name:'The Calm Ritual',blurb:'For reactive skin that has been through it.',handles:['softwater-cleanser','rescue-balm','second-skin-cream']}
  };
  window.NVDCQuiz = (() => {
    let s = { step:0, answers:{}, done:false };
    const titleize = h => h.replace(/-/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
    function render(root){
      if (s.done){
        const r = R[s.answers.concern] || R.brightness;
        root.innerHTML = `<div>
          <div class="eyebrow" style="text-align:center;margin-bottom:20px;">— Your ritual</div>
          <h1 class="h1" style="text-align:center;">Meet <em>${r.name}</em></h1>
          <p class="lede" style="text-align:center;margin:0 auto 40px;font-style:italic;">${r.blurb}</p>
          <div class="grid grid-3">${r.handles.map((h,i)=>`
            <a href="/products/${h}" class="card">
              <div class="eyebrow" style="margin-bottom:6px;">Step 0${i+1}</div>
              <div class="h3">${titleize(h)}</div>
            </a>`).join('')}</div>
          <form action="/cart/add" method="post" style="margin-top:40px;">
            ${r.handles.map(h=>`<input type="hidden" name="items[][id]" data-handle="${h}">`).join('')}
            <div class="quiz-bundle">
              <div><div class="eyebrow" style="color:var(--gold);margin-bottom:6px;">Bundle &amp; save 25%</div>
                <div style="font-family:var(--serif);font-size:28px;">Add all three to your bag</div></div>
              <button class="btn btn-gold" type="submit">Add ritual to bag →</button>
            </div>
          </form>
          <div style="text-align:center;margin-top:24px;"><button class="btn-link" onclick="NVDCQuiz.reset()">Retake the quiz</button></div>
        </div>`;
        return;
      }
      const q = Q[s.step]; const sel = s.answers[q.key];
      root.innerHTML = `<div>
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <div class="eyebrow">Question <span style="color:var(--text);">${s.step+1}</span> / ${Q.length}</div>
          <div class="eyebrow">~2 min · 6 questions</div>
        </div>
        <div class="quiz-progress" style="margin-bottom:40px;"><div style="width:${(s.step/Q.length)*100}%"></div></div>
        <div class="eyebrow" style="margin-bottom:16px;">${q.tag}</div>
        <h1 class="h1" style="font-size:56px;">${q.q}</h1>
        ${q.sub ? `<p style="font-family:var(--serif);font-style:italic;font-size:20px;color:var(--muted);margin:0 0 32px;">${q.sub}</p>` : ''}
        <div>${q.opts.map(o => `<button class="quiz-option ${sel===o.id?'is-selected':''}" data-pick="${o.id}">${o.l}</button>`).join('')}</div>
        <div class="quiz-nav">
          <button class="btn-link" ${s.step===0?'style="visibility:hidden;"':''} data-back>← Back</button>
          <button class="btn" data-next ${!sel?'style="opacity:.4;"':''}>${s.step===Q.length-1?'See my routine →':'Continue →'}</button>
        </div>
      </div>`;
      root.querySelectorAll('[data-pick]').forEach(b => b.addEventListener('click', () => { s.answers[q.key]=b.dataset.pick; render(root); }));
      const nx=root.querySelector('[data-next]'); if(nx) nx.addEventListener('click', () => { if(!s.answers[q.key])return; if(s.step===Q.length-1) s.done=true; else s.step++; render(root); });
      const bk=root.querySelector('[data-back]'); if(bk) bk.addEventListener('click', () => { s.step=Math.max(0,s.step-1); render(root); });
    }
    return { mount(el){ render(el); }, reset(){ s={step:0,answers:{},done:false}; const el=document.querySelector('[data-skin-quiz]'); if(el) render(el); } };
  })();
  document.addEventListener('DOMContentLoaded', () => { const q=document.querySelector('[data-skin-quiz]'); if(q) NVDCQuiz.mount(q); });
})();
